<script setup lang="ts">
definePageMeta({
  layout: 'blank',
})

const password = ref('')
const isPasswordVisible = ref(false)
const error = ref('')
const success = ref('')
const router = useRouter()

const cookie = useCookie('site_access', {
  maxAge: 60 * 60 * 24 * 7, // 7 days
})

const checkPassword = () => {
  if (password.value === 'Regenboog') {
    error.value = ''
    success.value = 'Wachtwoord correct! U wordt doorgestuurd...'
    cookie.value = 'granted'
    setTimeout(() => {
      router.push('/')
    }, 1500)
  }
  else {
    success.value = ''
    error.value = 'Onjuist wachtwoord'
  }
}
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-block-size: 100vh;"
  >
    <VCard
      width="400"
      class="pa-6 elevation-4"
    >
      <div class="d-flex justify-center mb-4">
        <Lottie
          link="/animations/tspeelfabrik.json"
          :height="150"
          :width="300"
          loop
          :speed="1.5"
        />
      </div>
      <VCardTitle class="text-center text-h5 mb-4">
        Website in opbouw
      </VCardTitle>

      <VCardText>
        <p class="text-center mb-6">
          Deze website is momenteel in opbouw. Voer het wachtwoord in voor toegang.
        </p>

        <form @submit.prevent="checkPassword">
          <VTextField
            id="password-input"
            v-model="password"
            label="Wachtwoord"
            :type="isPasswordVisible ? 'text' : 'password'"
            :append-inner-icon="isPasswordVisible ? 'bx-hide' : 'bx-show'"
            :error-messages="error"
            variant="outlined"
            autofocus
            autocomplete="current-password"
            @click:append-inner="isPasswordVisible = !isPasswordVisible"
          />
          <div
            v-if="success"
            class="text-success text-center mt-2 font-weight-bold"
          >
            {{ success }}
          </div>

          <VBtn
            block
            color="primary"
            size="large"
            type="submit"
            :loading="!!success"
            class="mt-4"
          >
            Verder
          </VBtn>
        </form>
      </VCardText>
    </VCard>
  </div>
</template>
